module.exports = __webpack_public_path__ + "static/share-image-42fb366199d9454c0da8b73c84f893db.jpg";